import React from "react";
import { Card, Grid } from "@mui/material";
import Title from "./../ReusableComponents/title";
import HeadAndDesc from "../ReusableComponents/HeadAndDesc";
import AvgProfitLoss from "../Charts/AvgProfitLoss";

const TradingdaysAnalysis = ({ data, days }) => {
  const {
    number_of_trade,
    negative_days,
    positive_days,
    avg_positive_days,
    avg_negative_days,
  } = data;

  return (
    <Grid container spacing={2} className="TradingdaysAnalysis">
      <Grid item xs={12} md={6} >
        <Card className="card-csc" sx={{marginLeft:'15px'}}>
          <Title six>Trading days anaysis</Title>
          <div className="d-flex mtt-20">
            <div
              className=""
              style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}
            >
              <HeadAndDesc
                HeadTitle="Number of days"
                SubTitle={days}
                HeadAndSubClassName="headAndDescBox"
              />
              <HeadAndDesc
                HeadTitle="Positive Days"
                SubTitle={positive_days && Number(positive_days).toFixed(2)}
                HeadAndSubClassName="headAndDescBox"
              />
              <HeadAndDesc
                HeadTitle="Negative Days"
                SubTitle={negative_days && Number(negative_days).toFixed(2)}
                HeadAndSubClassName="headAndDescBox"
              />

              <HeadAndDesc
                HeadTitle="Avg no. of trades"
                SubTitle={number_of_trade && Number(number_of_trade).toFixed(2)}
                HeadAndSubClassName="headAndDescBox"
              />
              <HeadAndDesc
                HeadTitle="Average Positive day"
                SubTitle={
                  avg_positive_days && Number(avg_positive_days).toFixed(2)
                }
                HeadAndSubClassName="headAndDescBox"
                SubTitleClass="Positive"
              />
              <HeadAndDesc
                HeadTitle="Average Negative day"
                SubTitle={
                  avg_negative_days && Number(avg_negative_days).toFixed(2)
                }
                HeadAndSubClassName="headAndDescBox"
                SubTitleClass="Negative"
              />
            </div>
          </div>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card className="card-csc">
          <Title six>Average profit / Average loss</Title>
          <AvgProfitLoss
            PositiveDays={Number(positive_days).toFixed(2)}
            NegativeDays={Number(negative_days).toFixed(2)}
          />
        </Card>
      </Grid>
    </Grid>
  );
};

export default TradingdaysAnalysis;
